const reliability = {
  create: "Reporte de Confiabilidad",
  profile: "PERFIL DE INSPECCIÓN DE CONFIABILIDAD",
  search: "Buscar",
  equipmentTag: "Tag del Equipo",
  equipmentType: "Tipo de Equipo",
  company: "Compañía",
  repairDate: "Fecha de Inspección de Confiabilidad",
  createdBy: "Creado Por",
  customer: "Cliente",
  Reliabilty: "Inspección de Confiabilidad",
  submit: "ENVIAR",
  list: "Lista de Inspecciones de Confiabilidad",
  delete: "ELIMINAR",
  lblselectdate: "Seleccione fecha y hora del reporte",
  lblmechanical: "Condicion Mecanica",
  trafficlights: {
    smooth: "En Servicio: Optimo",
    warning: "En Servicio: Advertencia",
    alarm: "En Servicio: Alarma"
  },
  conditions: {
    smooth: "Optimo",
    warning: "Advertencia",
    alarm: "Alarma"
  },
  datepicker: {
    title: "Escoja Rango de Fechas",
    okbtn: "LISTO",
    cancelbtn: "CANCELAR"
  },
  statuslights: {
    running: "En Servicio",
    standby: "En Reposo",
    maintenance: "En Mantenimiento",
    failure: "Fallando"
  },
  isThisAFailure: "¿Es una falla?",
  hint1: "Mas Detalles",
  hint2: "Resultados del analisis de confiabilidad",
  status: "Estatus",
  backbtn: "Atrás"
};
export default reliability;
